module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "base-list"
  }, [(!_vm.hideAddNew && _vm.hasPermission(_vm.createPermission)) ? _c('el-button', {
    staticClass: "add-button",
    attrs: {
      "type": "primary",
      "icon": "el-icon-plus"
    },
    on: {
      "click": _vm.addNew
    }
  }, [_vm._v(_vm._s(_vm.$t('button.new')))]) : _vm._e(), _vm._v(" "), _c('data-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "body": true
      }
    }],
    attrs: {
      "model": _vm.model,
      "columns": _vm.columns,
      "size": 10,
      "operations": _vm.operations
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('title.remove'),
      "visible": !!_vm.modelToDelete,
      "width": "30%",
      "before-close": function () {
        _vm.modelToDelete = null
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('remove.message')))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.modelToDelete = null
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.deleteModel
    }
  }, [_vm._v(_vm._s(_vm.$t('button.confirm')))])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e0f7ae88!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BaseList.vue
// module id = 1035
// module chunks = 2